export class MenuSearchService {
    search(items, query) {
        const normalizedQuery = this.normalize(query);
        if (normalizedQuery.length < 3)
            return [];
        return items
            .filter((item) => this.normalize(item.name).includes(normalizedQuery))
            .map((item) => ({ item }));
    }
    normalize(text) {
        return (text
            .toLowerCase() // case-insensitive matching
            // Simple way of handling diacritics (ą, ź, ś, ć, ł). Can be improved with a library if needed
            .normalize("NFD") // decompose accented chars into base + diacritic codepoints
            .replace(/[\u0300-\u036f]/g, "") // strip diacritics → é→e, ą→a, ó→o, etc.
            .replace(/\u0142/g, "l") // `ł` doesn't decompose via NFD, handle it explicitly
            .trim() // ignore surrounding whitespace
        );
    }
}
